/* eslint-disable react/destructuring-assignment */
import { Box, Divider, Typography, useTheme } from '@mui/material';
import React from 'react';

import { IPageTemplateProps } from '@orgnc/core/lib/themes/templates/page';
import getFirstOrDefault from '@orgnc/core/lib/utils/getFirstOrDefault';
import PageContent from '@orgnc/core/components/molecules/PageContent';
import SponsoredBrand from '@orgnc/core/components/molecules/SponsoredBrand';
import { CenterLayout } from '@orgnc/core/components/primitives';
import { useAimGeneralOptions } from '@/utils/useAimGeneralOptions';
import LatestPost from '@/components/templates/Article/shared/LatestPost';

export default function PageWithBuyingGuideSpotlight(
  props: IPageTemplateProps
): JSX.Element {
  const { buyingGuideSpotlightPost } = useAimGeneralOptions();
  const { breakpoints } = useTheme();
  // 840px is legacy default value for default page template
  let maxWidth = '840px';

  const postTemplate = getFirstOrDefault<string>(
    props?.page?.postTemplate?.postTemplate,
    ''
  );

  if (postTemplate === 'Wide') {
    maxWidth = `${breakpoints.values.xl}${breakpoints.unit}`;
  }

  return (
    <Box px={{ xs: 3, md: 5 }} py={4} sx={props.options?.sx ?? {}}>
      <CenterLayout maxWidth={maxWidth}>
        {props.page.title && (
          <Typography
            component="h1"
            dangerouslySetInnerHTML={{ __html: props.page.title }}
            sx={{ mb: 4 }}
            variant="h1"
          />
        )}
        {props.page.sponsored?.brand ? (
          <Box sx={{ my: 2 }}>
            <Divider />
            <SponsoredBrand
              enabled
              text={props.page.sponsored.text || ''}
              brand={props.page.sponsored.brand}
              sx={{ my: 1 }}
            />
            <Divider />
          </Box>
        ) : null}
        <PageContent
          blocks={props.page.blocks}
          useUncomfortableCPL={Boolean(props.options?.useUncomfortableCPL)}
          includeContentBlockStyling
        />
        {buyingGuideSpotlightPost ? (
          <LatestPost post={buyingGuideSpotlightPost} />
        ) : null}
        {props.afterContentSlot}
      </CenterLayout>
    </Box>
  );
}
